import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import { FunctionalComponent } from 'vue';
import { MaybeRef } from '@vueuse/core';

import {
    PuzzlePieceIcon,
    Cog8ToothIcon,
    CreditCardIcon,
    ChartPieIcon,
} from '@heroicons/vue/24/outline';

interface ILink {
    name: string;
    href: string;
    icon: FunctionalComponent;
    count?: MaybeRef<number>;
    id: string;
    tooltip?: string;
    new_feature_visited?: boolean;
}

export default () => {
    const page = computed(() => usePage<ITopolPageProps>().url);
    const globalProps = computed(() => usePage<ITopolPageProps>().props);

    const linksPlugin = computed((): ILink[] => {
        const links: ILink[] = [
            {
                name: 'Plugin',
                href: route('api-tokens.index'),
                icon: PuzzlePieceIcon,
                count: undefined,
                id: '/plugin',
            },
            {
                name: 'Usage statistics',
                href: route('usage-statistics'),
                icon: ChartPieIcon,
                count: undefined,
                id: '/usage-statistics',
            },
        ];

        if (
            globalProps.value.team_role.key === 'owner' ||
            globalProps.value.team_role.key === 'admin' ||
            globalProps.value.team_role.key === 'editor'
        ) {
            links.push({
                name: 'Settings',
                href: route('settings.profile-settings.index'),
                icon: Cog8ToothIcon,
                count: undefined,
                id: '/settings',
            });
        }

        if (globalProps.value.team_role.key === 'owner') {
            links.push({
                name: 'Billing',
                href: route('billing.pro-subscriptions.index'),
                icon: CreditCardIcon,
                count: undefined,
                id: '/billing/',
            });
        }

        return links;
    });

    return {
        links: linksPlugin,
    };
};

